import { useQuery } from 'react-query'
import xhr from 'Common/utils/xhr'

import { getCoursesUrl, showCourseUrl } from '../endpoints'

export function useGetCourses({
  page,
  level,
  categoryId,
  materialType,
  limit,
} = {}) {
  const {
    isLoading: loadingCourses,
    data: coursesData,
    refetch: refetchCourses,
  } = useQuery(
    ['courses', page, level, categoryId, materialType],
    () =>
      xhr({
        url: getCoursesUrl({ page, limit, categoryId, level, materialType }),
        method: 'get',
      }).then(res => {
        const data = {
          courses: res.data,
          currentPage: Number(res.headers['x-page']),
          totalPages: Number(res.headers['x-total-pages']),
        }
        return data
      }),
    { keepPreviousData: true }
  )

  return {
    loadingCourses,
    coursesData,
    refetchCourses,
  }
}

export function useGetCoursesCategories() {
  const { isLoading: loadingCategories, data: categories } = useQuery(
    'coursesCategories',
    () =>
      xhr({ url: '/api/v1/courses/categories', method: 'get' }).then(res => {
        res.data.unshift({ name: 'All', id: '' })
        return res.data
      })
  )

  return {
    loadingCategories,
    categories,
  }
}

export function useGetCourse({ slug }) {
  const { isLoading, data: courseData } = useQuery('course', () =>
    xhr({ url: showCourseUrl(slug), method: 'get' }).then(res => {
      return res.data
    })
  )

  return {
    isLoading,
    courseData,
  }
}
